import { get, post } from '@/utils/request'



// 根据资料工程ID获取视图信息 
export const getViewByProjectId = (projectId: any): Promise<any> => {
  return get(`/cmp-doc/data-project-view/getViewByProjectId`, { projectId }, {}, 'document')
}

// 根据资料工程ID获取视图文件夹信息
export const getViewsFolder = (projectId: any): Promise<any[]> => {
  return get(`/cmp-doc/data-project-view/getViewsFolder`, { projectId }, {}, 'document')
}

// 根据视图ID获取视图下所有文件夹和文件信息
export const getViewsFolderByViewId = (projectId: any, viewId: any): Promise<any> => {
  return get(`/cmp-doc/data-project-view/getViewsFolderByViewId`, { projectId, viewId }, {}, 'document')
}

// 根据视图ID获取视图信息
export const getTemplateViewByProjectViewId = (data: any): Promise<any> => {
  return get(`/cmp-doc/data-project-view/getViewById`, data, {}, 'document')
}

// 修改文档卷
export const updateProjectDocJuan = (params: any, requestId, projectId): Promise<void> => {
  return post(`/cmp-doc/data-project-view/updateCatalogDoc?requestId=${requestId}&projectId=${projectId}`, params, {}, 'document')
}

// 创建空文件
export const createEmptyFile = (params: any): Promise<any> => {
  return post(`/cmp-doc/data-project-file/create-empty`, params, {}, 'document')
}

// 创建模板文件
export const createTemplateFile = (params: any): Promise<any> => {
  return post(`/cmp-doc/data-project-file/create-template`, params, {}, 'document')
}

// 上传文件
export const uploadFile = (params: any): Promise<any> => {
  return post(`/cmp-doc/data-project-file/upload`, params, {}, 'document')
}

// 删除文件
export const deleteFile = (fileIds: number[]): Promise<any> => {
  return post(`/cmp-doc/data-project-file/delete`, fileIds, {}, 'document')
}

// 获取模板列表
export const getTemplateList = (params: any): Promise<any> => {
  return get(`/cmp-doc/template/list`, params, {}, 'document')
}

// 导出文件
export const exportFiles = (params: any): Promise<any> => {
  return post(`/cmp-doc/data-project-file/export`, params, {}, 'document')
}
